(function () {
  'use strict';

  // Collection/grid cards (pr_img_2, pr_img_2_equal): the second-image hover preview
  // video should only play while the card is actually hovered, instead of looping
  // for every card on the page regardless of visibility.
  var supportsHover = window.matchMedia ? window.matchMedia('(hover: hover)').matches : true;

  // Belt-and-suspenders on every input type: no matter how a card's "stop" signal
  // gets missed, only ever let one hover-preview video be playing at a time.
  var stopOtherHoverVideos = function (exceptVideo) {
    document.querySelectorAll('.hover_video').forEach(function (video) {
      if (video !== exceptVideo && !video.paused) {
        video.pause();
        video.currentTime = 0;
      }
    });
  };

  if (supportsHover) {
    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('.product-image');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      var video = card.querySelector('.hover_video');
      if (!video) return;
      stopOtherHoverVideos(video);
      video.play().catch(function () {});
    });

    document.addEventListener('mouseout', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('.product-image');
      if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
      var video = card.querySelector('.hover_video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  } else {
    // Touch devices have no real hover state (mouseover/mouseout don't fire there,
    // even though mobile browsers still simulate CSS :hover on tap, which is why the
    // overlay used to show up but the video never played). A tap is the closest
    // equivalent to mouseenter, so use touchstart as the play trigger. Viewport
    // visibility is only ever used to pause/clean up once a card is scrolled away -
    // never to start playback - otherwise every video visible in the grid at once
    // (e.g. a whole row on a phone screen) would autoplay together.
    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('.product-image');
      if (!card) return;
      var video = card.querySelector('.hover_video');
      if (!video) return;
      stopOtherHoverVideos(video);
      video.play().catch(function () {});
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var hoverVideoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            entry.target.pause();
            entry.target.currentTime = 0;
          }
        });
      }, { threshold: 0.25 });

      var scanForHoverVideos = function (root) {
        if (root.matches && root.matches('.hover_video')) hoverVideoObserver.observe(root);
        if (root.querySelectorAll) {
          root.querySelectorAll('.hover_video').forEach(function (video) {
            hoverVideoObserver.observe(video);
          });
        }
      };

      // Cards can also be appended later via infinite-scroll/AJAX, so a
      // MutationObserver picks up videos that weren't in the DOM at page load.
      var startObservingHoverVideos = function () {
        scanForHoverVideos(document);
        if ('MutationObserver' in window) {
          new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) scanForHoverVideos(node);
              });
            });
          }).observe(document.body, { childList: true, subtree: true });
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startObservingHoverVideos);
      } else {
        startObservingHoverVideos();
      }
    }
  }

  // Product detail page masonry gallery (media2.liquid): videos there are all
  // rendered into the DOM at once, so play/pause them based on actual viewport
  // visibility instead of looping from page load.
  function initViewportVideos() {
    if (!('IntersectionObserver' in window)) return;
    var videos = document.querySelectorAll('.js-viewport-video');
    if (!videos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.play().catch(function () {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.25 });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewportVideos);
  } else {
    initViewportVideos();
  }
})();
